import React, { useState } from "react";
import { Button, Menu, MenuItem, Box, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const ExportJobButton = ({ handleExport, loadingStates = {} }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const exportOptions = [
    {
      key: "jobs",
      label: t("admin.jobs.exportJobs"),
      loading: loadingStates.jobs,
    },
    {
      key: "departments",
      label: t("admin.jobs.exportDepartments"),
      loading: loadingStates.departments,
    },

    {
      key: "orgChartPptx",
      label: t("admin.jobs.exportOrgChartPptx"),
      loading: loadingStates.orgChartPptx,
    },
  ];

  const handleSelect = (key) => {
    handleExport(key);
    handleClose();
  };

  return (
    <Box>
      <MDButton
        color="primary"
        onClick={handleClick}
        sx={{
          "@media (max-width: 600px)": {
            width: "100%",
          },
        }}
      >
        {t("export")}
      </MDButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {exportOptions.map((option) => (
          <MenuItem key={option.key} onClick={() => handleSelect(option.key)}>
            {option.loading ? <CircularProgress size={20} /> : option.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

ExportJobButton.propTypes = {
  handleExport: PropTypes.func.isRequired,
  loadingStates: PropTypes.object,
};

export default ExportJobButton;
